import {mergeProperties} from "../components/Utility";
import ActionDropdown from "../components/actions/ActionDropdown";

export const getFormData = (data) => {
    const initialData = {
        name: '',
        // image: '',
        description: '',
        status: true,
        showInReport: false
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getAssignFormData = (data) => {
    const initialData = {
        apply: 0,
        products: []
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getUnassignedFormData = (data) => {
    const initialData = {
        apply: 0,
        products: []
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getTableColumns = () => {

    let tableColumns = [
        {header: "Name", field: "name"},
        {header: "Description", field: "description"},
    ];

    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row} assign={true} restricted={[{BranchAdmin: ['k']},{BranchOwner: ['k']},{BranchManager: ['k']}]}/>;
        },
    });
    return tableColumns;
};


export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        name: item.name,
        description: item.description,
    }));
}


export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            name: item?.name,
            description: item.description,
            status: item?.status ? "Active" : "Inactive",
            ...(item.showInReport !== undefined && {
                showInReport: item?.showInReport ? "Yes" : "No"
            })
        }
    };
}

export const getProductWithTagColumns = () => {
    let tableColumns = [
        {header: "Product", field: "product"},
    ];
    return tableColumns;
};

export const getProductWithTagData = ({productList, products}) => {
    if (!Array.isArray(products) || typeof productList !== 'object') return [];

    return products
        .filter(productId => productList[productId]) // Only include if product exists in productList
        .map(productId => ({
            product: productList[productId]
        }));
};









